export enum LoadingDescriptionKeys {
  LOADING_SERVICE = "LOADING_SERVICE",
}